import angular from 'angular';
import ngAnimate from 'angular-animate';
import ngRoute from 'angular-route';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
// import * as dynamicLocale from 'angular-dynamic-locale'; // Fails because it is a legacy module
import asyncFilter from 'angular1-async-filter';
import childuppCore from './core';

export default angular.module('childupp', [
    ngRoute,
    ngResource,
    ngSanitize,
    ngAnimate,
    'tmh.dynamicLocale', // dynamicLocale, // Fails because it is a legacy module
    'asyncFilter', // Fails because module doesn't expose its name
    childuppCore.name,
]);



// WEBPACK FOOTER //
// ./src/app/app.module.js